export default __webpack_public_path__ + "static/media/cox-new.baae1acf.png";